import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ProjectSubscriptionService} from '../../../shared/services/project-subscription/project-subscription.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SenceiveSubscription} from '../../../shared/classes/senceive-subscription/senceive-subscription';
import {StatesService} from '../../../shared/services/state/states.service';

@Component({
  selector: 'app-senceive-subscription',
  templateUrl: './senceive-subscription.component.html',
  styleUrls: ['./senceive-subscription.component.css']
})
export class SenceiveSubscriptionComponent implements OnInit {

  public faTimes = faTimes;
  public projectId: number;
  public senceiveSubscriptionId: number;
  public showSpinner: boolean;
  public senceiveSubscription: SenceiveSubscription;
  public senceiveSubscriptionForm: FormGroup;
  public projectName: string;

  constructor(private toastr: ToastrService,
              private projectSubscriptionService: ProjectSubscriptionService,
              private translate: TranslateService,
              public statesService: StatesService,
              @Inject(MAT_DIALOG_DATA) data: any) {
    this.projectId = data.project.id;
    this.projectName = data.project.name;
    this.senceiveSubscriptionId = data.senceiveSubscriptionId;
    this.senceiveSubscriptionForm = new FormGroup({
      senceiveProjectId: new FormControl('', [Validators.required, Validators.minLength(2),
        Validators.maxLength(50)]),
      senceiveUser: new FormControl('', [Validators.required, Validators.email]),
      senceivePassword: new FormControl('', [Validators.required, Validators.minLength(2),
        Validators.maxLength(50)])
    });

  }

  ngOnInit() {
    this.getSenceiveSubscription();
  }

  public get senceiveProjectId() {
    return this.senceiveSubscriptionForm.get('senceiveProjectId');
  }

  public get errorSenceiveProjectId(): string {

    if (this.senceiveProjectId.errors.required) {
      return this.translate.instant('VALUE_FORM_REQUIRED');
    }

    if (this.senceiveProjectId.errors.minlength) {
      return this.translate.instant('VALUE_USER_NAME_TOO_SHORT');
    }

    if (this.senceiveProjectId.errors.maxlength) {
      return this.translate.instant('VALUE_USER_NAME_TOO_LONG');
    }
    return '';
  }

  public get senceiveUser() {
    return this.senceiveSubscriptionForm.get('senceiveUser');
  }

  public get errorSenceiveUser(): string {

    return this.senceiveUser.errors.required || this.senceiveUser.errors.email ? this.translate.instant('EMAIL_INVALID') : '';
  }

  public get senceivePassword() {
    return this.senceiveSubscriptionForm.get('senceivePassword');
  }

  public get errorSenceivePassword(): string {

    if (this.senceivePassword.errors.required) {
      return this.translate.instant('VALUE_FORM_REQUIRED');
    }

    if (this.senceivePassword.errors.minlength) {
      return this.translate.instant('VALUE_USER_NAME_TOO_SHORT');
    }

    if (this.senceivePassword.errors.maxlength) {
      return this.translate.instant('VALUE_USER_NAME_TOO_LONG');
    }
    return '';
  }

  getSenceiveSubscription() {
    if (this.senceiveSubscriptionId !== null) {
      this.showSpinner = true;
      this.projectSubscriptionService.getSenceiveSubscription(this.senceiveSubscriptionId).subscribe(
        (senceiveSubscription: SenceiveSubscription) => {
          this.toastr.success(this.translate.instant('DATA_LOADED'), this.translate.instant('SUCCESS'));
          this.senceiveSubscription = senceiveSubscription;
          this.senceiveSubscriptionForm.patchValue({
            senceiveProjectId: this.senceiveSubscription.senceiveProjectId,
            senceiveUser: this.senceiveSubscription.senceiveUser,
            senceivePassword: this.senceiveSubscription.senceivePassword
          });
          this.showSpinner = false;
        }, error => {
          this.showSpinner = false;
        });
    }
  }

  postSenceiveSubscription() {
    if (this.senceiveSubscriptionForm.valid) {
      let senceiveSubscriptionToPost = new SenceiveSubscription();
      senceiveSubscriptionToPost.osmosProjectId = this.projectId;
      senceiveSubscriptionToPost.senceiveProjectId = this.senceiveSubscriptionForm.value.senceiveProjectId;
      senceiveSubscriptionToPost.senceiveUser = this.senceiveSubscriptionForm.value.senceiveUser;
      senceiveSubscriptionToPost.senceivePassword = this.senceiveSubscriptionForm.value.senceivePassword;
      if (JSON.stringify(senceiveSubscriptionToPost) === JSON.stringify(this.senceiveSubscription)) {
        this.toastr.error(this.translate.instant('SAVING_DISABLED_MESSAGE'), this.translate.instant('ERROR'));
      } else {
        this.showSpinner = true;
        this.senceiveSubscription = senceiveSubscriptionToPost;
        this.projectSubscriptionService.postSenceiveSubscription(this.senceiveSubscription).subscribe(
          d => {
            this.statesService.reloadListProject.next();
            this.toastr.success(this.translate.instant('SUBSCRIPTION_CREATED'), this.translate.instant('SUCCESS'));
            this.showSpinner = false;
          },
          error => {
            this.showSpinner = false;
          });
      }
    }
  }


}
